import React from 'react';
import { Building, Calendar, CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const MoreProjectsPage = () => {
  const projects = [
    {
      title: "EPC Works for The Conversion of HABSHAN-3 NGI Compressor Project",
      client: "ADNOC",
      year: "2022-2023",
      description: "PMC Services for following Disciplines:",
      services: [
        "Process Engineering",
        "Piping Engineering",
        "Electrical Engineering",
        "Instrumentation & Control Engineering",
        "Civil & Structural Engineering"
      ]
    },
    {
      title: "EPC for BAB Gas Compression Project (BGCP) PHASE III",
      client: "ADNOC",
      year: "2022-2023",
      description: "Detailed Engineering Services for following Disciplines:",
      services: [
        "Process Engineering",
        "Piping Engineering",
        "Electrical Engineering",
        "Instrumentation & Control Engineering",
        "Technical Safety (HSE) Engineering"
      ]
    },
    {
      title: "Engineering Services for Camp Borouge 4 Project - EPC Package 2 (Ethane Cracker)",
      client: "ADNOC",
      year: "2022-2023",
      description: "Detailed Engineering Services for camp design which includes:",
      services: [
        "Camp layout in line with civil defence requirements",
        "Fire Fighting System design",
        "Sewage, drainage, and storm water layouts",
        "F&G Detection and alarm network layout & details",
        "Building layout and details",
        "TV/Telephone & CCTV details",
        "Overall camp design and engineering"
      ]
    },
    {
      title: "EPC For Asab Phase II (Stage 2) Project-Camp Approvals And Engineering Services",
      client: "ADNOC",
      year: "2022-2023",
      description: "Detailed Engineering Services for temporary site facilities design which includes:",
      services: [
        "Camp layout in line with civil defence requirements",
        "Fire Fighting System design",
        "Sewage, drainage, and storm water layouts",
        "F&G Detection and alarm network layout & details",
        "Building layout and details",
        "TV/Telephone & CCTV details",
        "Overall temporary site facilities design and engineering"
      ]
    },
    {
      title: "EPC For Transfer Line In Shah & Water Handling In Shah & Quashwira",
      client: "ADNOC Onshore",
      year: "2022-2023",
      description: "Feed Verification Services for following disciplines:",
      services: [
        "Process Engineering",
        "Pipeline Engineering",
        "Piping Engineering",
        "Mechanical Engineering",
        "Electrical Engineering",
        "Instrumentation Engineering",
        "Telecom Engineering",
        "Civil/Structural Engineering",
        "Technical Safety (HSE) Engineering",
        "Material & Corrosion Engineering"
      ]
    },
    {
      title: "Delay Analysis And The Extension Of Time For EPC For Bab 485 Mbd Sustainable Facilities Project",
      client: "ADNOC Onshore",
      year: "2022",
      description: "",
      services: []
    },
    {
      title: "Process Simulation for Scope Definition Study (Phase 2) For ADOC Future Power Supply",
      client: "ADOC",
      year: "2023",
      description: "Process Simulation Services for Scope definition study for ADOC future Power Supply which includes:",
      services: [
        "Process Simulation Report",
        "Process",
        "P&IDs",
        "PFDs",
        "Cause & Effect",
        "Datasheet",
        "Equipment list"
      ]
    },
    {
      title: "Engineering, Procurement and Construction for Ruwais NGL Potable Water packages Train #1 &2 Project",
      client: "ADNOC Gas Processing",
      year: "2021",
      description: "3D Modelling Services for the Train 1 & 2 Potable water network:",
      services: [
        "3D Model Development for all Disciplines in SP3D software",
        "30%, 60%, 90% Review",
        "Tags Clearance",
        "GADs, ISOMETRICS & Layouts, MTO Extraction",
        "Close out"
      ]
    },
    {
      title: "Engineering, Procurement and Construction for Pump Packaging Project",
      client: "HES International Rotterdam, Netherlands",
      year: "2021",
      description: "3D Modelling Services for Pump Packaging:",
      services: [
        "3D Model Development for all Disciplines in PDMS software",
        "30%, 60%, 90% Review",
        "Tags Clearance",
        "GADs, ISOMETRICS & Layouts, MTO Extraction",
        "Close out"
      ]
    },
    {
      title: "EPC of Cluster M1 with Access Road and Security Facilities at Cluster M3 at the West Qurna (Phase 2) Contract Area",
      client: "Lukoil Mid-East Limited, West Qurna, Iraq",
      year: "2019-2020",
      description: "Detailed Engineering Services for Facilities at West Qurna 2 Oil & Gas Field which included:",
      services: [
        "Oil Wells Clusters Design Development",
        "Security Facilities Design Development",
        "Auxiliary Piping & Plumbing works",
        "Access Roads & Bridge Design",
        "Oil Police Entry Check Point Design",
        "Telecom & Security System Design"
      ]
    },
    {
      title: "EPC of GRE Pipeline for Rumaila Project",
      client: "British Petroleum (BP)",
      year: "2019-2021",
      description: "Detailed Engineering Services for GRE Pipeline including following Key Deliverables:",
      services: [
        "Pipe wall thickness Calculations",
        "Piping & Instrumentation Diagrams (P & IDs)",
        "Pipeline Alignment Sheets",
        "Piping Isometrics (including tie-in) and MTO estimation",
        "General Arrangement Drawings (GADs) for support location and support detailing",
        "Road crossing details",
        "Datasheet, Material requisition (MRs) and Technical Bid Evaluation (TBE) for Valve and Pipe",
        "Stress Analysis"
      ]
    },
    {
      title: "Engineering, Procurement and Construction for Well Pad Expansion and Hook-Up of Historical Wells at The West Qurna (Phase 2) Contract Area",
      client: "Lukoil Mid-East Limited, West Qurna, Iraq",
      year: "2019",
      description: "Detail Engineering Services for Historical Wells at West Qurna 2 Oil & Gas Field which includes:",
      services: [
        "New Warehouse",
        "Office Buildings",
        "Engineering Procedures such as Pressure Leak Test for Piping System, PWHT, HSE etc.",
        "Inspection & Test Plans (ITPs) such as Piping, Electrical Works, Earthworks, Steel Structure Works, T-Wall etc.",
        "Method Statements"
      ]
    },
    {
      title: "Engineering, Procurement & Construction for Dammam Water Injection Wells at West Qurna 2 Contract Area",
      client: "Lukoil Middle East Limited, West Qurna, Iraq",
      year: "2018-2019",
      description: "Engineering Services for Dammam Water Injection Wells at West Qurna 2 Oil & Gas Field which includes:",
      services: [
        "3D Model update using PDMS software for Well Pads #2, #5 & #12 and approval of the same"
      ]
    },
    {
      title: "Engineering, Procurement & Construction for Dammam Water Injection Wells at West Qurna 2 Contract Area",
      client: "Lukoil Middle East Limited, West Qurna, Iraq",
      year: "2018-2019",
      description: "Engineering Services for Dammam Water Injection Wells at West Qurna 2 Oil & Gas Field which includes:",
      services: [
        "Preparation of As-Built Drawings & Documents"
      ]
    },
    {
      title: "Engineering, Procurement, Construction and commissioning for Workbase Infrastructure Construction",
      client: "China National Offshore Oil Corporation (CNOOC)",
      year: "2020",
      description: "Pre-Bid Engineering for the Tender Development which included following Key Deliverables:",
      services: [
        "Technical Proposal for Buildings",
        "Project Schedule",
        "Preliminary Bill of Quantities (BOQs) for Civil/Structural works, Piping, Electrical and Telecom & Security system",
        "Sample Reporting Template"
      ]
    },
    {
      title: "Engineering, Procurement & Construction for Dammam Water Injection Wells at West Qurna 2 Contract Area",
      client: "Lukoil Middle East Limited, West Qurna, Iraq",
      year: "2018",
      description: "Technical Writing Development & Approval of Documents for Dammam Water Injection Wells at West Qurna 2 Oil & Gas Field which includes:",
      services: [
        "Interface Management Plan",
        "Engineering Procedures such as Interface Management, Pressure Leak Test for Piping System, PWHT etc.",
        "Inspection & Test Plans (ITPs) such as Piping (AG/UG), Electrical Works, Instrumentation, Cathodic Protection, Painting etc.",
        "Method Statements"
      ]
    },
    {
      title: "Engineering, Procurement & Construction for Production Well Pad 4 & 9 at the West Qurna (Phase 2) Contract Area",
      client: "Lukoil Middle East Limited, West Qurna, Iraq",
      year: "2018",
      description: "Pre-Bid Engineering for the Tender Development which included following Key Deliverables:",
      services: [
        "Technical Proposal",
        "Project Execution Plans & Strategies",
        "Engineering Deliverable Document Register (EDDR)",
        "Project Schedule",
        "Project Controls Procedures"
      ]
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-80 flex items-center justify-center overflow-hidden bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">More Projects</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Additional engineering excellence across major developments
          </p>
        </div>
      </section>

      {/* Projects List */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {projects.map((project, index) => (
              <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-8">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
                    <h3 className="text-2xl font-bold text-slate-900 flex-1">
                      {index + 1}. {project.title}
                    </h3>
                  </div>
                  
                  <div className="flex flex-wrap gap-6 mb-6">
                    <div className="flex items-center gap-2">
                      <Building className="w-5 h-5 text-red-600" />
                      <span className="text-slate-600">
                        <span className="font-semibold">Client:</span> {project.client}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Calendar className="w-5 h-5 text-red-600" />
                      <span className="text-slate-600">
                        <span className="font-semibold">Year:</span> {project.year}
                      </span>
                    </div>
                  </div>

                  {project.description && (
                    <p className="text-slate-700 mb-4 font-medium">{project.description}</p>
                  )}

                  {project.services.length > 0 && (
                    <div className="grid md:grid-cols-2 gap-3">
                      {project.services.map((service, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                          <span className="text-slate-600">{service}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default MoreProjectsPage;
